// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__qY2O8","slider_content":"Slider_slider_content__D+TYa","fadeOut":"Slider_fadeOut__tF1es","fadeIn":"Slider_fadeIn__rh6cX"};